<template>
  <div 
    class="mood-bar"
    :style="{
      border: '1px solid #d1d5db',
      borderRadius: '0.5rem',
      backgroundColor: 'white'
    }"
  >
    <div class="flex flex-col p-2">
      <h3 class="text-sm font-semibold text-neutral-500 mb-2">Wie fühlst du dich heute?</h3>
      
      <!-- Emoji buttons with fade-out animation -->
      <div 
        v-if="!selectedMood" 
        class="flex justify-between space-x-2"
        :class="{ 'fade-out': isAnimating }"
      >
        <button 
          v-for="(mood, index) in moods" 
          :key="index"
          @click="selectMood(mood)"
          class="mood-emoji cursor-pointer bg-neutral-50 w-14 h-14 flex items-center justify-center text-xl rounded-full hover:bg-neutral-100 transition-colors"
          :style="{
            border: '1px solid #f5f5f5'
          }"
        >
          {{ mood.emoji }}
        </button>
      </div>

      <!-- Thank you message with fade-in animation -->
      <div 
        v-else 
        class="thank-you-content text-center"
        :class="{ 'fade-in': showThankYou }"
      >
        <div class="flex flex-row justify-center space-x-2  items-center">
          <BxGift class="text-yellow-500 text-3xl mb-1" />
          <p class="text-neutral-800 font-bold text-md">Vielen Dank!</p>
        </div>
        <button 
          @click="resetSelection" 
          class=" text-xs text-neutral-600 hover:text-black underline"
        >
          Neu auswählen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BxGift } from '@kalimahapps/vue-icons';

export default {
  name: 'MoodBar',
  components: {
    BxGift
  },
  data() {
    return {
      selectedMood: null,
      isAnimating: false,
      showThankYou: false,
      moods: [
        { emoji: '😀', label: 'Zufrieden', value: 'happy', numericValue: 4 },
        { emoji: '😐', label: 'Neutral', value: 'neutral', numericValue: 3 },
        { emoji: '😕', label: 'Unzufrieden', value: 'sad', numericValue: 2 },
        { emoji: '😡', label: 'Verärgert', value: 'angry', numericValue: 1 }
      ]
    };
  },
  methods: {
    selectMood(mood) {
      this.isAnimating = true;
      
      // Wait for fade-out animation to complete
      setTimeout(() => {
        this.selectedMood = mood;
        this.showThankYou = true;
        
        // Emit both the text value and numeric value
        this.$emit('mood-selected', {
          textValue: mood.value,
          numericValue: mood.numericValue,
          label: mood.label,
          emoji: mood.emoji
        });
      }, 300);
    },
    resetSelection() {
      this.selectedMood = null;
      this.isAnimating = false;
      this.showThankYou = false;
      this.$emit('mood-reset');
    }
  }
};
</script>

<style scoped>
.fade-out {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.thank-you-content {
  opacity: 0;
  transform: translateY(10px);
}

.fade-in {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.4s ease 0.1s, transform 0.4s ease 0.1s;
}

.mood-emoji {
  transition: all 0.2s ease;
}

.mood-emoji:hover {
  transform: scale(1.05);
}
</style>